// export const BASE_URL = "http://192.168.1.220:8082/api/";

// export const BASE_URL = "http://192.168.1.220:8081/api/";

export const BASE_URL = "http://66.116.207.210:8080/synergy/api/";